import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { Avatar } from '../styles/GlobalStyles';
import { FiMessageSquare } from 'react-icons/fi';

export default function UnreadMessagesNotifications() {
  const { state, dispatch } = useApp();
  const [usersById, setUsersById] = useState({});

  const unread = Object.entries(state.unreadByUser || {})
    .filter(([_, count]) => Number(count) > 0)
    .map(([id, count]) => ({ userId: Number(id), count: Number(count) }))
    .filter(x => !Number.isNaN(x.userId));

  useEffect(() => {
    if (!unread.length) return;
    const needFetch = unread.some(m => !usersById[m.userId]);
    if (!needFetch) return;

    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch('/api/users', {
          headers: { Authorization: `Bearer ${token}` }
        });
        const list = await res.json();
        if (Array.isArray(list)) {
          const map = {};
          list.forEach(u => {
            if (u && u.id != null) map[Number(u.id)] = u;
          });
          setUsersById(prev => ({ ...prev, ...map }));
        }
      } catch (e) {
        console.error('UnreadMessagesNotifications: failed to load users', e);
      }
    };

    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(unread)]);

  if (!unread.length) return null;

  const chats = state.chats || [];

  const entries = unread
    .map(item => {
      const chatId = (state.lastUnreadChatByUser || {})[item.userId];
      const chat = chats.find(c => Number(c.id) === Number(chatId));
      if (!chat) return null;
      return { ...item, chat };
    })
    .filter(Boolean);

  if (!entries.length) return null;

  const top = entries
    .slice()
    .sort((a, b) => b.count - a.count)
    .slice(0, 3);

  const openChat = (userId, chat) => {
    dispatch({ type: 'SET_CURRENT_CHAT', payload: chat });
    dispatch({ type: 'MARK_CHAT_AS_READ', payload: { chatId: chat.id, participants: chat.participants } });
    dispatch({ type: 'CLEAR_UNREAD_BY_USER', payload: { userId } });
    if (window.socket && window.socket.connected) {
      window.socket.emit('join_chat', chat.id);
      window.socket.emit('mark_chat_read', chat.id);
      // Обновляем список сообщений, чтобы увидеть последние
      window.socket.emit('get_chat_messages', chat.id);
      window.socket.emit('get_pinned_messages', chat.id);
    }
    if (window.setMessengerView) window.setMessengerView('chat');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {top.map(item => {
        const user = usersById[item.userId] || {};
        const name =
          user.username ||
          [user.first_name, user.last_name].filter(Boolean).join(' ') ||
          `ID ${item.userId}`;
        const avatarUrl = user.avatar || user.avatar_url;
        const preview = (state.lastUnreadPreviewByUser || {})[item.userId] || '';

        return (
          <div
            key={item.userId}
            onClick={() => openChat(item.userId, item.chat)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              // Форма как у пузыря сообщения в чате
              background: 'linear-gradient(135deg, #5eead4 0%, #22c55e 45%, #16a34a 100%)',
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              borderBottomRightRadius: 20,
              borderBottomLeftRadius: 0,
              padding: '12px 18px',
              boxShadow: '0 10px 30px rgba(15,23,42,0.55)',
              border: '1px solid rgba(15,23,42,0.45)',
              pointerEvents: 'auto',
              cursor: 'pointer',
              minWidth: 320,
              maxWidth: 380,
              position: 'relative',
              overflow: 'visible'
            }}
          >
            {/* Без хвостика – как плоский пузырь сообщения */}
            {/* Кружок-счётчик, как значок уведомления */}
            {item.count > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: -10,
                  right: -10,
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  background: '#1d4ed8',
                  border: '2px solid #e5f2ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#ffffff',
                  fontWeight: 800,
                  fontSize: '0.9rem',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.35)'
                }}
              >
                {item.count > 9 ? '9+' : item.count}
              </div>
            )}
            <Avatar
              size="38px"
              online={false}
              style={{
                overflow: 'hidden',
                background: '#1f2937',
                borderRadius: '50%',
                boxShadow: '0 2px 6px rgba(0,0,0,0.35)'
              }}
            >
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '50%'
                  }}
                />
              ) : (
                <span style={{ fontSize: '0.85rem' }}>
                  {(name || '?').charAt(0).toUpperCase()}
                </span>
              )}
            </Avatar>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  color: '#e5e7eb',
                  fontWeight: 700,
                  fontSize: '1.15rem',
                  marginBottom: 4,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                title={name}
              >
                {name}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  fontSize: '1.12rem',
                  color: '#e5f3ff',
                  marginBottom: 2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                <FiMessageSquare size={19} style={{ color: '#e0f2ff' }} />
                <span style={{ fontWeight: 500 }}>{preview}</span>
              </div>
              {item.count > 1 && (
                <div style={{ fontSize: '0.98rem', color: '#e0f2ff' }}>
                  Всего новых сообщений: {item.count}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

